import * as React from "react";
import { Grid } from "semantic-ui-react";
import { PlayerVideoCatalystListComponent } from "@/components/Lists/PlayerVideoCatalystListComponent";
import "./styles.scss";

interface Props {}

const VideoCatalystFC: React.FC<Props> = () => {
  return (
    <Grid className={"videoCatalystListComponentContainer"} data-elm-id="playerVideoCatalystListComponent">
      <Grid.Row>
        <Grid.Column>
          <PlayerVideoCatalystListComponent
            key={"player_video_catalyst_list_c"}
            showError={error => {
              alert(error);
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export const PlayerVideoCatalyst = VideoCatalystFC;
